import { memo } from "react";

import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog/dialog";

import { useHotelFullUrls } from "@/components/features-new/hotel-top/components/_shared/use-hotel-full-urls";
import { LinkButton } from "@/components/features-new/hotel-top/components/island/hotel-urls/hotel-urls/components/link-button";
import { URL_TYPES } from "@/components/features-new/hotel-top/components/island/hotel-urls/hotel-urls/constants";

type Props = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	hotelUrls: HotelTopQuery["hotelUrls"];
};

export const CompletionDialog = memo(({ open, onOpenChange, hotelUrls }: Props) => {
	const { fullUrlPlain, fullUrlMagazine, fullUrlSnack } = useHotelFullUrls(hotelUrls);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-fit">
				<DialogHeader>
					<DialogTitle className="text-center text-xl">🎉 おめでとうございます！</DialogTitle>
					<DialogDescription className="text-center text-base text-zinc-700">
						すべての販売開始前のチェックが完了しました。
						<br />
						販売を開始する準備が整いました！
					</DialogDescription>
				</DialogHeader>

				<div className="space-y-4 pt-2">
					<p className="text-sm font-bold text-zinc-800">以下のURLからお客様が予約できるようになります</p>
					<div className="space-y-4">
						{fullUrlMagazine && (
							<div className="space-y-1">
								<p className="text-sm font-medium text-zinc-600">{URL_TYPES.MAGAZINE.title}</p>
								<LinkButton url={fullUrlMagazine} textColor="link" />
							</div>
						)}
						{fullUrlPlain && (
							<div className="space-y-1">
								<p className="text-sm font-medium text-zinc-600">{URL_TYPES.PLAIN.title}</p>
								<LinkButton url={fullUrlPlain} textColor="link" />
							</div>
						)}
						{fullUrlSnack && (
							<div className="space-y-1">
								<p className="text-sm font-medium text-zinc-600">{URL_TYPES.SNACK.title}</p>
								<LinkButton url={fullUrlSnack} textColor="link" />
							</div>
						)}
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
});

CompletionDialog.displayName = "CompletionDialog";
